export default {
  clientID: process.env.CLIENTID,
  domain: "signonglass.au.auth0.com",
  redirectUri: process.env.FRONT_END + "/callback",
  audience: "https://signonglass.au.auth0.com/userinfo"
};
